import { Locale } from "modules/i18n/locale-config";
import { extendTranslation } from "../../../brand-utils";
import defaultTranslation from "../../default/messages/is";

export default extendTranslation(defaultTranslation, {
  locale: Locale.IS.code,
  messages: {
    "root.desc": `Velkomin/n! <br/>
Þú hefur tekið fyrsta skrefið að bættri heilsu. <br/>
Næsta skref er að framkvæma sjálfsskimun og mun Healo - stafræni sjúkraþjálfarinn ávísa meðferð að skimun lokinni. <br/>
Meðferðin er svo send í Healo smáforritið, en það má finna bæði í App Store og Play store <br/> 
Athugið að spurningarnar í sjálfskimuninni eru á ensku`
  }
});



// WEBPACK FOOTER //
// ./src/modules/brand/brands/as/messages/is.js